module.exports = __webpack_public_path__ + "static/media/user-admin-preview.7e0e9e62.png";